/** Aviso global: la última sincronización no se publicó.
 *
 * Del 16 al 24 de septiembre de 2026 ninguna corrida se publicó y la plataforma
 * no lo dijo en ninguna parte: el panel seguía enseñando la última corrida buena
 * como si fuera la de hoy, y la pantalla de Corridas decía «Validando». Este
 * aviso sale en todas las pantallas mientras la corrida más reciente sea una
 * fallida, y dice de cuándo son las cifras que se están viendo.
 *
 * El color nunca va solo: lleva el distintivo «Error» y el texto.
 */
import { Link } from "react-router-dom";
import type { LastRun } from "../api/types";
import { formatDateTime } from "./format";
import { StatusBadge } from "./StatusBadge";

export function AvisoCorrida({ corrida }: { corrida: LastRun | null | undefined }) {
  if (!corrida || corrida.status !== "failed") return null;

  const reglas = corrida.reglas_bloqueantes ?? [];
  return (
    <div className="card banner critical" role="alert">
      <StatusBadge tone="critical">Error</StatusBadge>
      <div className="banner-body">
        <strong>
          La última sincronización no se publicó ({formatDateTime(corrida.started_at)})
        </strong>
        <p className="small">
          {corrida.ultima_publicada
            ? `Las cifras que ve son de la corrida publicada del ${formatDateTime(corrida.ultima_publicada)}.`
            : "Todavía no hay ninguna corrida publicada."}
          {reglas.length > 0 &&
            ` Fallaron ${reglas.length} validación${reglas.length === 1 ? "" : "es"} bloqueante${reglas.length === 1 ? "" : "s"}.`}
        </p>
        <p className="small">
          <Link to={`/runs/${corrida.sync_run_id}`}>Ver el detalle de la corrida</Link>
        </p>
      </div>
    </div>
  );
}
